import { Link } from 'react-router-dom'

interface FindLegalDocumentProps {
  className?: string
}

export const FindLegalDocument = ({
  className = '',
}: FindLegalDocumentProps) => {
  return (
    <p
      className={`text-xs xl:text-sm 2xl:text-base text-[#6E7785] font-[500] ${className}`}
    >
      Need help finding a legal document?
      <Link
        className='ml-[8px] hover:[#6596D7] text-[#001A3D] text-xs xl:text-sm 2xl:text-base font-medium underline '
        to='/legal-documents'
      >
        Click here
      </Link>
    </p>
  )
}
